@if (selectedNotification) {
  <div
    class="notification-bar w-100 d-flex align-items-center {{ theme$ | async }}"
    [ngClass]="selectedNotification.itemClass"
    [@notificationAnimation]="animationState"
    (@notificationAnimation.done)="onAnimationDone($event)"
  >
    <div class="notification-content">
      <i
        class="far mr-2 notification-icon {{ theme$ | async }}"
        [ngClass]="selectedNotification.notificationIcon"
      ></i>

      <span class="notification-message">
        {{ selectedNotification.message }}
      </span>

      @if (!selectedNotification.openReleaseNotes && selectedNotification.url) {
        <a
          [href]="selectedNotification.url"
          target="_blank"
          rel="noopener noreferrer"
          class="ml-3 banner-link"
        >
          {{ 'NOTIFICATION.LEARN_MORE' | translate }}
        </a>
      }

      @if (selectedNotification.openReleaseNotes) {
        <a
          (click)="openReleaseNotes()"
          class="ml-3 banner-link banner-link--button"
        >
          {{ 'NOTIFICATION.RELEASE_NOTES.RELEASE_NOTES' | translate }}
        </a>
      }
    </div>
    <!-- Navigation chevrons -->
    @if (unreadNotifications.length > 0) {
      <div class="notification-navigation d-flex align-items-center">
        <div
          class="banner-button font-weight-bold cursor-pointer font-size-regular mx-3"
          (click)="previousNotification()"
          [ngStyle]="{ visibility: currentUnreadIndex !== 0 ? 'visible' : 'hidden' }"
        >
          <i class="far fa-chevron-left pointer"></i>
        </div>

        <span class="notification-counter">
          {{ 'NOTIFICATION.NOTIFICATION' | translate }}
          {{ currentUnreadIndex + 1 }}
          {{ 'COMMON.OF' | translate }}
          {{ unreadNotifications.length }}
        </span>

        <div
          class="banner-button font-weight-bold cursor-pointer font-size-regular mx-3"
          (click)="nextNotification()"
          [ngStyle]="{
            visibility: currentUnreadIndex !== unreadNotifications.length - 1 ? 'visible' : 'hidden',
          }"
        >
          <i class="far fa-chevron-right pointer"></i>
        </div>
      </div>
    }

    <div
      [ngStyle]="{ visibility: selectedNotification.dismissible ? 'visible' : 'hidden' }"
      class="notification-close banner-button font-weight-bold cursor-pointer font-size-regular ml-3"
      (click)="markAsRead()"
    >
      <i class="far fa-times"></i>
    </div>
  </div>
}
